<template>
  <div class="home-container">

    <div class="main-content">
      <!-- message list -->
      <div class="message-list" v-if="messageList.length">
        <div class="message-icon"><i class="el-icon-message-solid"></i></div>
        <div class="message-viewport">
          <div
            class="message-track"
            :style="{
              transform: `translateY(-${messageIndex * 32}px)`,
              transition: messageTransition ? 'transform 100ms ease' : 'none'
            }"
          >
            <div
              v-for="(item, index) in visibleMessageList"
              :key="`${item.Bid}-${index}`"
              class="message-item"
              @click="goMessageDetail(item)"
            >
              {{ item.Title }}
            </div>
          </div>
        </div>
      </div>


      <HashPowerOrb
        :globalHashPower="userInfo?.total_pps||'0'"
        globalUnit="TH/s"
        :myHashPower="userInfo?.user_pps||'0'"
        myUnit="TH/s"
        :stats="[
          { label: $t('hashPower.stats.directPool'), value: userInfo?.aa_pool||'0', color: '#FF6B35' },
          { label: $t('hashPower.stats.simGoldPool'), value: userInfo?.bb_pool||'0', color: '#FFD700' },
        ]"
      />


      <div class="participate-section">
        <!-- <div class="participate-bg-text">PARTICIPATE</div> -->
        <div class="participate-title">{{ $t('home.participateNow') }}</div>
        
        <div class="participate-card" v-if="!isConnected||!userInfo">
          <div class="connect-btn-wrapper"  @click="navConnectWallet">
            <div class="submit-btn">{{ $t('navbar.connectWallet') }}</div>
          </div>
        </div>
        <div class="participate-card" v-else-if="userInfo">
          <div class="wallet-info-row">
            <div class="address">{{userInfo&&userInfo.address?shortAddress:""}}</div>
            <div class="quota-text">{{ $t('home.participatedQuota') }} <span class="highlight">{{userInfo?.join_amt || '0'}}</span> USDT</div>
          </div>
          <div class="wallet-info-row sub">
            <div class="balance">{{ $t('home.walletAvailable') }} {{ walletUsdtBalance }} USDT</div>
            <div class="quota-text">{{ $t('home.remainingQuota') }} {{userInfo?.bal_amt || '0'}} USDT</div>
          </div>

          <div v-if="userInfo?.bal_amt&&userInfo?.bal_amt>0">
            <div class="input-section">
              <div class="label-row">
                <span>{{ $t('home.participateAmount') }}</span>
                <span>{{ $t('home.amountRange') }}</span>
              </div>
              <div class="input-box">
                <input type="number" v-model="amount" class="amount-input" min="100" step="100" @blur="normalizeAmount" />
                <span class="currency">USDT</span>
              </div>
            </div>

            <div class="slider-container">
              <div class="slider-labels top">
                <span>100USDT</span>
                <span class="current-val">{{ amount }}USDT</span>
                <span>{{userInfo?.bal_amt}} USDT</span>
              </div>
              <el-slider v-model="amount" :min="100" :max="Number(userInfo?.bal_amt)||10000" :step="100" :show-tooltip="false"
                class="custom-slider"></el-slider>
            </div>

            <div class="preset-buttons">
              <div v-for="val in presets" :key="val" class="preset-btn" :class="{ active: selectedPreset === val,disabled:userInfo?.bal_amt&&userInfo?.bal_amt<parseFloat(val) }"
                @click="selectPreset(val)">
                {{ val }}
              </div>
            </div>

            <div class="submit-btn" :class="{ disabled: isParticipating||disable }" @click="submitParticipate">
              {{ $t('home.participateNow') }} · {{ amount }}USDT
            </div>
          </div>
          <div v-else class="max">
            <img src="@/assets/img/shouye/jinggao.png" alt="" />
            <div class="max-title">{{ $t('home.maxTitle') }}</div>
            <!-- {{ $t('home.maxDesc') }} -->
            <div class="max-desc"></div>
          </div>
          <div></div>
        </div>
      </div>
    </div>

    <Tabbar />

    <Popover ref="participateSuccess">
      <div class="participate-success">
        <div class="success-header">
          <img src="@/assets/img/popover/success.png" class="success-icon" alt="success" />
          <div class="success-title">{{ $t('home.participateSuccessTitle') }}</div>
          <div class="success-subtitle">{{ $t('home.participateSuccessSubtitle') }}</div>
        </div>

        <div class="amount-card">
          <div class="amount-label">{{ $t('home.participateAmount') }}</div>
          <div class="amount-row">
            <div class="amount-value">{{ participateAmount }}</div>
            <div class="amount-unit">USDT</div>
          </div>
        </div>

        <div class="hash-section">
          <div class="hash-label">{{ $t('common.txHash') }}</div>
          <div class="hash-row">
            <div class="hash-value">{{ participateTxHash }}</div>
            <div class="hash-copy" @click="copyHash">{{ $t('common.copy') }}</div>
          </div>
        </div>

        <div class="success-btn" @click="closeParticipateSuccess">{{ $t('home.confirmDone') }}</div>
      </div>
    </Popover>
    
    <Popover ref="participate_banned" :maskClosable="false" :closable="false" :zIndex="1000">
      <img src="@/assets/img/popover/warning.png" class="banned_icon" />
      <div class="banned_text">{{ $t('common.accountBanned') }}</div>
    </Popover>

    <Popover ref="popoverNotice" class="notice-popover" :maskClosable="false">
        <div class="popover-content-box">
          <!-- <div class="notice-title">{{ noticeData.Title}}</div> -->
          <!-- <div class="notice-content" v-html="noticeData.Content || ''"></div> -->
           <img :src="noticeData.Attach" class="notice-img" @click="toDetail">
        </div>
    </Popover>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Tabbar from '@/components/Tabbar.vue';
import HashPowerOrb from '@/components/HashPowerOrb.vue';
import Popover from '@/components/popover.vue';
import { CHAIN_CONFIG } from '@/config/chain'

const TARGET_CONTRACT = CHAIN_CONFIG.contracts.deposit
const USDT_ADDRESS = CHAIN_CONFIG.contracts.usdt
const BNB_FEE = CHAIN_CONFIG.fees.depositBnb
const SELECTOR_ALLOWANCE = CHAIN_CONFIG.selectors.allowance
const SELECTOR_APPROVE = CHAIN_CONFIG.selectors.approve
const SELECTOR_DEPOSIT = CHAIN_CONFIG.selectors.deposit
const SELECTOR_BALANCE_OF = CHAIN_CONFIG.selectors.balanceOf

export default {
  name: 'HomeView',
  components: {
    Navbar,
    Tabbar,
    HashPowerOrb,
    Popover
  },
  data() {
    return {
      amount: 1000,
      sending:true,
      presets: ['100', '500', '1K', '5K', '10K'],
      selectedPreset: '1K',
      participateAmount: '0',
      participateTxHash: '',
      isParticipating: false,
      disable:false,
      walletUsdtBalance: '--',
      messageIndex: 0,
      messageTimer: null,
      messageResetTimer: null,
      messageTransition: true,
      messageList:[],
      noticeData:{}
    };
  },
  created() {
    this.$store.state.showNavbar = true
  },
  computed: {
    changeLang(){
      return this.$store.state.changeLang
    },
    isConnected() {
      return this.$store.state.wallet.isConnected
    },
    userInfo() {
      return this.$store.state.userInfo
    },
    walletAddress() {
      return this.$store.getters.walletAddress
    },
    shortAddress() {
      return this.$store.getters.shortWalletAddress
    },
    visibleMessageList() {
      if (this.messageList.length <= 1) return this.messageList
      return this.messageList.concat(this.messageList[0])
    },
  },
  mounted() {
    setTimeout(() => {
      this.sending = false
    }, 2000)
    this.startMessageRoll()
  },
  beforeDestroy() {
    this.stopMessageRoll()
  },
  watch: {
    changeLang(){
      this.getMsgList(true)
    },
    isConnected() {
      this.$emit('changeConnect', this.isConnected)
    },
    amount(val) {
      // Update selected preset if matches
      const kVal = val >= 1000 ? (val / 1000) + 'K' : val.toString();
      if (this.presets.includes(kVal)) {
        this.selectedPreset = kVal;
      } else {
        this.selectedPreset = '';
      }
    },
    userInfo: {
      immediate: true,
      handler(){
        if(this.userInfo && this.userInfo.uid){
          this.getMsgList(false)
        }
      }
    },
    walletAddress: {
      immediate: true,
      handler(addr) {
        if (!addr) {
          this.walletUsdtBalance = '--'
          return
        }
        this.fetchWalletUsdtBalance(addr)
        const token = localStorage.getItem('BearerToken')
        if (token&& !this.userInfo && !this.sending) this.getUserInfo(addr)
      }
    }
  },
  methods: {
    toDetail(){
      this.$router.push('/details?Bid=' + this.noticeData.Bid)
    },
    getNotice(){
      this.$store.state.showNotice = false
      this.$post("/user/notice_list",{
        lang: this.$i18n && this.$i18n.locale ? this.$i18n.locale : 'en',
        type: 1,
        num:1
      }).then(res => {
        if (res.code === 0) {
          const next = res.data || []
          this.noticeData = next[0]||{}
          if(this.noticeData.Title){
            this.$refs.popoverNotice.open()
          }
        }else{
          const errorMessage = this.$getMsg(res.code)
          this.$message({
            message: errorMessage,
            type: 'error'
          })
        }
      })
    },
    getMsgList(reset){
      if(this.$store.state.showNotice){
        this.getNotice()
      }
      this.$post("/user/notice_list",{
        lang: this.$i18n && this.$i18n.locale ? this.$i18n.locale : 'en',
        type: 0,
        num:1
      }).then(res => {
        if(reset){
          this.messageList = []
        }
        if (res.code === 0) {
          const next = res.data || []
          this.messageList = this.messageList.concat(next)
          this.$nextTick(this.startMessageRoll)
        }else{
          const errorMessage = this.$getMsg(res.code)
          this.$message({
            message: errorMessage,
            type: 'error'
          })
        }
      }).catch(() => {
      }).finally(() => {
      })
    },
    goMessageDetail(item) {
      if (!item || !item.Bid) return
      this.$router.push('/details?Bid=' + item.Bid)
    },
    startMessageRoll() {
      this.stopMessageRoll()
      this.messageIndex = 0
      this.messageTransition = true
      if (this.messageList.length <= 1) return
      this.messageTimer = setInterval(() => {
        this.messageTransition = true
        this.messageIndex += 1
        if (this.messageIndex === this.messageList.length) {
          this.messageResetTimer = setTimeout(() => {
            this.messageTransition = false
            this.messageIndex = 0
            this.$nextTick(() => {
              this.messageResetTimer = setTimeout(() => {
                this.messageTransition = true
              }, 20)
            })
          }, 120)
        }
      }, 2200)
    },
    stopMessageRoll() {
      if (this.messageTimer) {
        clearInterval(this.messageTimer)
        this.messageTimer = null
      }
      if (this.messageResetTimer) {
        clearTimeout(this.messageResetTimer)
        this.messageResetTimer = null
      }
    },
    navConnectWallet() {
      this.$parent.connectWallet()
    },
    pad32Hex(hex) {
      const h = (hex || '').toLowerCase().replace(/^0x/, '')
      return h.padStart(64, '0')
    },
    toHex(n) {
      return '0x' + (n < 0n ? (n + (1n << 256n)) : n).toString(16)
    },
    parseUnits(value, decimals) {
      const d = Number(decimals)
      if (!Number.isFinite(d) || d < 0) throw new Error(this.$t('common.decimalsInvalid'))

      const s = String(value)
      const parts = s.split('.')
      const i = parts[0] ? parts[0] : '0'
      const f0 = parts[1] ? parts[1] : ''
      const f = f0.padEnd(d, '0').slice(0, d)

      let base = 1n
      for (let k = 0; k < d; k++) base *= 10n

      const intPart = BigInt(i) * base
      const fracPart = f ? BigInt(f) : 0n
      return intPart + fracPart
    },
    formatUnits(value, decimals) {
      const d = Number(decimals)
      if (!Number.isFinite(d) || d < 0) return '0'

      const s = (typeof value === 'bigint' ? value : BigInt(value)).toString()
      if (d === 0) return s

      const neg = s.startsWith('-')
      const abs = neg ? s.slice(1) : s
      const pad = abs.padStart(d + 1, '0')
      const intPart = pad.slice(0, -d)
      const fracPart = pad.slice(-d).replace(/0+$/, '')
      const out = fracPart ? `${intPart}.${fracPart}` : intPart
      return neg ? `-${out}` : out
    },
    async waitForReceipt(txHash) {
      const eth = window.ethereum
      if (!eth || !eth.request) throw new Error(this.$t('common.installWallet'))

      for (let i = 0; i < 60; i++) {
        const receipt = await eth.request({
          method: 'eth_getTransactionReceipt',
          params: [txHash]
        })
        if (receipt) {
          if (receipt.status && receipt.status.toLowerCase() === '0x0') {
            throw new Error(this.$t('common.txFailed'))
          }
          return receipt
        }
        await new Promise(r => setTimeout(r, 2000))
      }
      throw new Error(this.$t('common.txTimeout'))
    },
    async fetchWalletUsdtBalance(addr) {
      const eth = window.ethereum
      if (!eth || !eth.request || !addr) return
      try {
        const data = SELECTOR_BALANCE_OF + this.pad32Hex(addr)
        const hex = await eth.request({
          method: 'eth_call',
          params: [{ to: USDT_ADDRESS, data }, 'latest']
        })
        const balWei = BigInt(hex || '0x0')
        const bal = this.formatUnits(balWei, 18)
        const n = Number(bal)
        this.walletUsdtBalance = Number.isFinite(n) ? n.toFixed(2) : bal
      } catch (e) {
        this.walletUsdtBalance = '--'
      }
    },
    onAmountInput(e) {
      const raw = e && e.target ? e.target.value : this.amount
      if (raw === '' || raw === null || raw === undefined) {
        this.amount = ''
        return
      }
      const n = Math.floor(Number(raw))
      if (!Number.isFinite(n)) return
      this.amount = n
    },
    normalizeAmount() {
      // const n = Math.floor(Number(this.amount))
      // if (!Number.isFinite(n)) {
      //   this.amount = 100
      //   return
      // }
      // let next = n
      // if (next < 100) next = 100
      // if (next % 100 !== 0) next = Math.floor(next / 100) * 100
      // if (String(next) !== String(this.amount)) {
      //   this.amount = next
      //   return
      // }
    },
    selectPreset(val) {
      this.selectedPreset = val;
      if (val.includes('K')) {
        this.amount = parseFloat(val) * 1000;
      } else {
        this.amount = parseInt(val);
      }
    },
    async submitParticipate() {
      if (this.isParticipating||this.disable) return

      const n = Math.floor(Number(this.amount))
      if (!Number.isFinite(n) || n < 100 || n % 100 !== 0) {
        this.$message({
          message: this.$t('home.amountMultiple100'),
          type: 'warning'
        })
        return
      }

      const eth = window.ethereum
      if (!eth || !eth.request) {
        this.$message({
          message: this.$t('common.installWallet'),
          type: 'error'
        })
        return
      }

      this.isParticipating = true
      try {
        const addr = await this.$store.dispatch('connectWallet')
        if (!addr) throw new Error(this.$t('common.walletNotConnected'))

        const amountWei = this.parseUnits(String(n), 18)
        const feeWei = this.parseUnits(BNB_FEE, 18)

        const allowanceData = SELECTOR_ALLOWANCE + this.pad32Hex(addr) + this.pad32Hex(TARGET_CONTRACT)
        const allowanceHex = await eth.request({
          method: 'eth_call',
          params: [
            { to: USDT_ADDRESS, data: allowanceData },
            'latest'
          ]
        })
        const allowance = BigInt(allowanceHex || '0x0')

        if (allowance < amountWei) {
          const approveData = SELECTOR_APPROVE + this.pad32Hex(TARGET_CONTRACT) + this.pad32Hex(this.toHex(amountWei))
          const approveHash = await eth.request({
            method: 'eth_sendTransaction',
            params: [
              { from: addr, to: USDT_ADDRESS, data: approveData }
            ]
          })
          await this.waitForReceipt(approveHash)
        }

        const depositData = SELECTOR_DEPOSIT + this.pad32Hex(this.toHex(amountWei))
        const depositHash = await eth.request({
          method: 'eth_sendTransaction',
          params: [
            { from: addr, to: TARGET_CONTRACT, data: depositData, value: this.toHex(feeWei) }
          ]
        })

        this.participateTxHash = depositHash
        this.participateAmount = String(n)
        await this.waitForReceipt(depositHash)
        this.$refs.participateSuccess.open()
        await this.confirmBuy(this.participateTxHash,this.participateAmount)
        setTimeout(() => {
          this.getUserInfo()
        }, 15000)
      } catch (e) {
        this.$message({
          message: (e && e.message) ? e.message : this.$t('home.participateFailed'),
          type: 'error'
        })
      } finally {
        this.isParticipating = false
      }
    },
    
    async confirmBuy(txHash,amount){
      if (!txHash) throw new Error(this.$t('common.txHashEmpty'))
      this.$post("/amount/deposit_confirm",{
        token:"usdt",
        hash: txHash,
        amount: amount
      }).then(async res => {
        if(res.code != 0){
          const errorMessage = this.$getMsg(res.code)
          this.$message({
            message: errorMessage,
            type: 'error'
          })
        }
      })
    },
    async getUserInfo(address){
      const addr = address || this.walletAddress || this.$store.state.wallet.address
      const conneted = localStorage.getItem("@appkit/connection_status")
      if(!addr || conneted !== 'connected') return
      const token = localStorage.getItem('BearerToken')
      if (!token) return
      this.$post('/user/info', {
        address: addr
      }).then(res => {
        if(res.code === 0){
          const userInfo = res?.data
          if(!userInfo){
            this.$message({
              message: this.$t('home.userInfoFailed'),
              type: 'error'
            })
            return
          }
          this.getMsgList(false)
          this.$store.commit('setUserInfo', userInfo)
        }else{
          const errorMessage = this.$getMsg(res.code)
          this.$message({
            message: errorMessage,
            type: 'error'
          })
        }
      })
    },
    closeParticipateSuccess() {
      this.$store.state.userInfo.join_amt = Number(this.participateAmount)+Number(this.$store.state.userInfo.join_amt)
      this.$store.state.userInfo.bal_amt = Number(this.$store.state.userInfo.bal_amt)-Number(this.participateAmount)
      this.$refs.participateSuccess.close()
    },
    async copyHash() {
      const text = this.participateTxHash || ''
      if (!text) return
      this.$copyText(text).then(
        () => {
          this.$message({
            message: this.$t('common.copied'),
            type: 'success'
          })
        },
        (err) => {
          this.$message({
            message: this.$t('common.copyFailed'),
            type: 'error'
          })
        }
      )
    }
  }
}
</script>

<style scoped lang="scss">
.submit-btn,
.preset-btn,
.hash-copy,
.success-btn,
.connect-btn-wrapper {
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  user-select: none;
  will-change: transform;
  transition: transform 0.16s ease, filter 0.16s ease, opacity 0.16s ease;
}

.submit-btn:not(.disabled):hover,
.preset-btn:not(.disabled):hover,
.hash-copy:hover,
.success-btn:hover,
.connect-btn-wrapper:hover {
  transform: scale(0.98);
  filter: brightness(0.96);
}

.submit-btn:not(.disabled):active,
.preset-btn:not(.disabled):active,
.hash-copy:active,
.success-btn:active,
.connect-btn-wrapper:active {
  transform: scale(0.98);
  filter: brightness(0.96);
}

.home-container {
  min-height: 100vh;
  background-color: #000;
  color: #fff;
  padding-bottom: 80px;
  /* Space for tabbar */
  position: relative;
  overflow-x: hidden;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  background-image: url('@/assets/img/shouye/bg.png');
  background-size: 1920px 2030px;
  background-position: 27px;
  background-repeat: no-repeat;
}

.main-content {
  padding: 80px 0 20px; /* Increased top padding to accommodate fixed navbar */
}

.message-list {
  height: 36px;
  margin: 0 15px 0;
  padding: 0 12px;
  border-radius: 18px;
  border: 1px solid rgba(255, 64, 26, 0.22);
  background: rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  overflow: hidden;
  box-sizing: border-box;
}

.message-icon {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  margin-right: 8px;
  background: #FF401A;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 900;
  flex: 0 0 auto;
}

.message-viewport {
  height: 32px;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.message-track {
  display: flex;
  flex-direction: column;
  transition: transform 200ms ease;
}

.message-item {
  height: 32px;
  line-height: 32px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 13px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.header-text {
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  color: rgba(255, 255, 255, 0.2);
  letter-spacing: 2px;
  margin-bottom: 20px;
}

.bubbles-section {
  display: flex;
  justify-content: center;
  align-items: center;
  /* Align items vertically center or change to flex-start based on design */

  .bubble {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    &:first-child {
      width: 258px;
      height: 248px;
    }

    &:last-child {
      width: 100px;
      height: 100px;
      position: relative;
      left: -20px;
    }

    .bubble-bg-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      display: flex;
      justify-content: center;
      align-items: center;

      .bubble-bg {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .bubble-content {
      position: relative;
      z-index: 2;
      text-align: center;

      .label {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.6);
        margin-bottom: 5px;
      }

      .value-group {
        color: #FF5621;
        font-weight: bold;
        font-size: 24px;

        &.yellow {
          color: #FFC107;
        }
      }

      .unit {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.6);
      }
    }
  }
}

.stats-cards {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 15px;

  .card {
    flex: 1;
    background: rgba(255, 64, 26, 0.05);
    border: 1px solid rgba(255, 64, 26, 0.20);
    border-radius: 12px;
    padding: 15px;
    text-align: center;

    .value {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 5px;

      &.red-text {
        color: #FF5621;
      }

      &.yellow-text {
        color: #FFC107;
      }
    }

    .label {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.6);
    }
  }
}

.participate-section {
  position: relative;
  text-align: center;
  padding: 8px 15px;
  margin-top: 25px;
  .participate-bg-text {
    font-size: 24px;
    font-weight: bold;
    color: rgba(255, 255, 255, 0.2);
    letter-spacing: 4px;
    position: absolute;
    top: 10px;
    left: 0;
    width: 100%;
    z-index: 1;
  }

  .participate-title {
    font-size: 18px;
    font-weight: bold;
    color: #fff;
    margin-bottom: 30px;
    position: relative;
    z-index: 2;
  }

  .participate-card {
    background: linear-gradient(180deg, rgba(30, 30, 30, 0.9) 0%, rgba(10, 10, 10, 0.95) 100%);
    border-radius: 16px;
    padding: 20px;
    text-align: left;
    position: relative;
    z-index: 2;

    /* Gradient border implementation */
    border: 1px solid transparent;
    background-clip: padding-box, border-box;
    background-origin: padding-box, border-box;
    background-image: linear-gradient(180deg, rgba(30, 30, 30, 0.9) 0%, rgba(10, 10, 10, 0.95) 100%), linear-gradient(180deg, #FF401A 0%, rgba(255, 64, 26, 0.20) 100%);
    .connect-btn-wrapper{
      margin: 60px auto;
      display: flex;
      justify-content: center;
      
    }
    
  .submit-btn {
    background: #FF401A;
    border-radius: 8px;
    padding: 15px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    cursor: pointer;
    &.disabled{
      opacity: 0.6;
      pointer-events: none;
    }
  }
    .max{
      display: flex;
      flex-direction: column;
      gap: 10px;
      align-items: center;
      margin-bottom: 20px;
      margin-top: 24px;
      img{
        width: 160px;
        height: 80px;
      }
      .max-title{
        color: #FFF;
        font-family: "Alibaba PuHuiTi 2.0";
        font-size: 16px;
        font-style: normal;
        font-weight: 900;
        line-height: 100%; /* 16px */
      }
      .max-desc{
        color: rgba(255, 255, 255, 0.40);
        font-family: "PingFang SC";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 100%; /* 14px */
        margin-bottom: 40px;
      }
    }
    .wallet-info-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      font-size: 14px;

      &.sub {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.5);
        padding-bottom: 10px;
        border-bottom: 1px solid rgba(255, 64, 26, 0.10);
      }

      .address {
        font-weight: bold;
      }

      .quota-text {
        font-size: 12px;

        .highlight {
          font-size: 16px;
          color: #FF5621;
          font-weight: bold;
        }
      }
    }
    .input-section {
      margin-bottom: 20px;

      .label-row {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.5);
        margin-bottom: 8px;
      }

      .input-box {
        background: rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        padding: 10px 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .amount-input {
          background: transparent;
          border: none;
          color: #fff;
          font-size: 20px;
          font-weight: bold;
          width: 80%;
          outline: none;
        }

        .currency {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.6);
        }
      }
    }

    .slider-container {
      margin-bottom: 25px;

      .slider-labels {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.3);
        margin-bottom: 5px;

        .current-val {
          color: #FF5621;
        }
      }

      /* Element UI Slider Customization */
      ::v-deep .el-slider__bar {
        background-color: #FF5621;
      }

      ::v-deep .el-slider__button {
        border-color: #FF5621;
        background-color: #FF5621;
      }

      ::v-deep .el-slider__runway {
        background-color: rgba(255, 255, 255, 0.1);
      }
    }

    .preset-buttons {
      display: flex;
      justify-content: space-between;
      margin-bottom: 25px;

      .preset-btn {
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 8px;
        padding: 8px 0;
        width: 18%;
        text-align: center;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.6);
        cursor: pointer;

        &.active {
          border-color: #FF401A;
          color: #FF401A;
        }
        &.disabled{
          cursor: not-allowed;
          opacity: 0.5;
          pointer-events: none;
        }
      }
    }

  }
}
.popover-content-box{
  width: 100%;
  .notice-title{
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  margin-bottom: 10px;
}
.notice-content{
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 32px;
  max-height: 300px;
  overflow: auto;
  text-align: left;
}
.notice-img{
  width: 85%;
  max-width: 325px;
  border-radius: 10px;  
}
}


.participate-success{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  .success-header{
    width: 200.5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }
  .success-icon{
    width: 160px;
    height: 80px;
    display: block;
  }
  .success-title{
    color: #FFF;
    font-family: "Alibaba PuHuiTi 2.0";
    font-size: 16px;
    font-style: normal;
    font-weight: 900;
    line-height: 16px;
    text-align: center;
  }
  .success-subtitle{
    color: rgba(255, 255, 255, 0.40);
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;
    text-align: center;
  }
  .amount-card{
    display: flex;
    padding: 16px 0;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-radius: 8px;
    border: 1px solid rgba(255, 64, 26, 0.30);
    background: rgba(255, 64, 26, 0.05);
    box-sizing: border-box;
  }
  .amount-label{
    color: rgba(255, 255, 255, 0.40);
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;
  }
  .amount-row{
    display: flex;
    align-items: flex-end;
    gap: 4px;
  }
  .amount-value{
    font-family: "Alibaba PuHuiTi 2.0";
    font-size: 32px;
    font-style: normal;
    font-weight: 900;
    line-height: 32px;
    background: linear-gradient(270deg, #FFDFB2 0%, #B28A62 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
  .amount-unit{
    color: rgba(255, 255, 255, 0.40);
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 16.8px;
    padding-bottom: 2px;
  }
  .hash-section{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
  .hash-label{
    color: rgba(255, 255, 255, 0.30);
    font-family: "PingFang SC";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
  }
  .hash-row{
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 12px 16px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.10);
    box-sizing: border-box;
  }
  .hash-value{
    flex: 1;
    color: rgba(255, 255, 255, 0.50);
    font-family: "PingFang SC";
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 13px;
    word-break: break-all;
    text-align: left;
  }
  .hash-copy{
    display: flex;
    background: #FF401A;
    height: 24px;
    padding: 0 6px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid rgba(255, 255, 255, 0.10);
    color: #FFF;
    font-family: "PingFang SC";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
    box-sizing: border-box;
  }
  .success-btn{
    display: flex;
    height: 48px;
    padding: 0 6.894px;
    justify-content: center;
    align-items: center;
    gap: 2.155px;
    align-self: stretch;
    border-radius: 8px;
    background: #FF401A;
    color: #FFF;
    font-family: "PingFang SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    box-sizing: border-box;
  }
}
</style>
<style>

.el-message{
  min-width: 325px !important;
  max-width: 325px !important;
}
</style>
